// @flow
import React, { useContext, useState } from 'react';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { getFormikFormInputsFromColConfigAndInputSource } from '@src/common-utils/utils';
import { StyledContainer } from '@src/common-utils/styledComponents';
import { Formik } from 'formik';
import { Form } from '@src/formik-utils/formikSUIWrapper';
import { SP_ORG_TOP_LEVEL_CONFIG } from '@streaming-projects/orgs/config';
import { SPOrgAccordionsContainer } from '@streaming-projects/orgs/org-top-level/SPOrgAccordionsContainer';
import { CUSTOM_DISCOUNTS_JSON_BACKEND_NAME } from '@src/constants';
import { SPORGCopyContainer } from '@streaming-projects/orgs/org-top-level/SPORGCopyContainer';
import { SPORGShareModal } from '@streaming-projects/orgs/org-top-level/sharing/SPORGShareModal';
import { ShareButton } from '@presentational/buttons/ShareButton';
import { If } from '@presentational/If';
import { IS_ORG_SHARING_LIVE } from '@streaming-projects/constants';
import useDoesUserHaveEarlyAccess from '@streaming-projects/useDoesUserHaveEarlyAccess';
import { SPOrgCustomerViewContainer } from '@streaming-projects/orgs/org-top-level/customer-view/SPOrgCustomerViewContainer';
import { CHECKBOX_INPUT_TYPE } from '@src/formik-utils/consts';
import { CUSTOMER_VIEW_ENUMS } from '@streaming-projects/orgs/enums';
import { SP_CUSTOM_DISCOUNTS_JSON_CONFIG } from '@streaming-projects/user-commit-details/config';

export const SPOrgTopLevelContainerForm = () => {
  const spOrgData = useContext(SPOrgContext);
  const doesUserHaveEarlyAccess = useDoesUserHaveEarlyAccess();
  const [isShareModalOpen, setShareModalOpen] = useState(false);
  const spOrgInputsSource = {
    ...spOrgData?.org,
    [CUSTOM_DISCOUNTS_JSON_BACKEND_NAME]: spOrgData?.discounts ?? {},
  };
  const spOrgConfig = [
    ...SP_ORG_TOP_LEVEL_CONFIG,
    SP_CUSTOM_DISCOUNTS_JSON_CONFIG,
    {
      displayName: CUSTOMER_VIEW_ENUMS.DISPLAY_NAME,
      backendFieldName: CUSTOMER_VIEW_ENUMS.BACKEND_NAME,
      inputType: CHECKBOX_INPUT_TYPE,
    },
  ];

  const { initialValues, initialTouched, validationSchema } =
    getFormikFormInputsFromColConfigAndInputSource(spOrgConfig, spOrgInputsSource, spOrgData);

  return (
    <StyledContainer>
      <Formik
        enableReinitialize={true}
        initialTouched={initialTouched}
        initialValues={initialValues}
        onSubmit={() => {}}
        validateOnMount={true}
        validationSchema={validationSchema}
      >
        {() => (
          <Form autoComplete="off">
            <SPORGCopyContainer />
            <If test={IS_ORG_SHARING_LIVE && doesUserHaveEarlyAccess}>
              <ShareButton
                onClick={() => {
                  setShareModalOpen(true);
                }}
                size="large"
              />
            </If>
            <SPOrgCustomerViewContainer />
            <SPORGShareModal
              isOpen={isShareModalOpen}
              orgId={spOrgInputsSource.id}
              orgName={spOrgInputsSource.sfdc_org_name}
              setOpen={setShareModalOpen}
            />
            <SPOrgAccordionsContainer />
          </Form>
        )}
      </Formik>
    </StyledContainer>
  );
};
